import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useTranslation } from "react-i18next";

export const DeleteDialog = ({ onAccept, onDecline, open }) => {
  const [t] = useTranslation();
  return (
    <Dialog open={Boolean(open)} onClose={onDecline}>
      <DialogTitle>{t("Xóa dữ liệu")}</DialogTitle>
      <DialogContent>{t("Bạn có chắc chắn xoá bản ghi này khỏi hệ thống")}?</DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onAccept}>
          {t("Đồng ý")}
        </Button>
        <Button onClick={onDecline}>{t("Hủy bỏ")}</Button>
      </DialogActions>
    </Dialog>
  );
};
